<template>
  <h2 class="heading">Get a {{ bonus }} BIRTHDAY VOUCHER</h2>

  <p class="text">
    Add your birthday to your Members Only account and get a
    {{ bonus }} birthday voucher. Every year from us, to you.
  </p>

  <BenefitIcons
    :items="{
      voucher: `Get ${bonus} gift for your birthday`,
    }"
  />

  <form>
    <label class="field">
      <div class="input">
        <input
          v-model.trim="birthday"
          type="date"
          class="input__element"
          autocomplete="bday"
          placeholder="Enter D.O.B"
        />
        <div v-if="v$.birthday.$dirty" class="input__response">
          <ul>
            <li v-for="error of v$.birthday.$errors" :key="error.$uid">
              {{ error.$message }}
            </li>
            <li v-for="error in errors" :key="error.message">
              {{ error.message }}
            </li>
          </ul>
        </div>
      </div>
    </label>

    <Button full-width @click="handleFormSubmit">Save Birthday</Button>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import Button from "@/components/Button.vue";
import BenefitIcons from "@/components/BenefitIcons.vue";
import { mapState, mapGetters } from "vuex";
import { birthdayBonus } from "@/config";
import { birthdayCaptureEvent } from "@/helpers/events.js";

export default {
  name: "DateOfBirthForm",
  components: {
    Button,
    BenefitIcons,
  },
  emits: ["success"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      birthday: null,
      success: false,
      submitted: false,
      errors: [],
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("auth", ["customer"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = birthdayBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    async handleFormSubmit() {
      this.submitted = false;

      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }
      const customerId = this.customer.id;

      const input = {
        id: customerId,
        birthday: this.birthday,
      };

      const resp = await fetch(
        `${process.env.RATANDBOA_NODE_APP_URL}/customer/account`,
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(input),
        }
      );

      this.submitted = true;

      if (!resp.ok) {
        const json = await resp.json();
        this.errors = json.errors;
        this.success = false;
        return;
      }

      this.success = true;

      birthdayCaptureEvent({ location: "data collection" });

      this.$emit("success");
    },
  },
  validations() {
    return {
      birthday: {
        required,
        maxValue: helpers.withMessage("Date cannot be in the future", (val) => {
          return new Date(val) < new Date();
        }),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.heading {
  margin-top: 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
}

.text {
  font-size: 13px;
  margin: 10px 0 50px 0;
  text-align: center;
  font-weight: 400;
  font-family: $body-font-family;
}

::v-deep(.loyalty-benefits-icons) {
  margin: 30px auto;

  @include respond-above(md) {
    margin: 30px auto;
  }

  p {
    font-size: 13px;
  }
}
</style>
